import apiCall from '../utils/api-call/apiCall';
import { createHeaders } from './constants';

const getAllApisWithSubscription = async () => {
  const headers = createHeaders();
  return await apiCall('all-apis-with-subscription', 'GET', {}, headers);
};

export { getAllApisWithSubscription };